import * as React from 'react'
import {RegImportInputDataControl} from './RegImportInputDataControl'
import {RegImportReadValidations} from './RegImportReadValidations'
import {RegImportConnectValidations} from './RegImportConnectValidations'
import {RegImportAction} from './RegImportAction'
export const RegImportControl = () => {
  return (
    <div style={{overflow: 'auto', height: '100%'}}>
      <RegImportInputDataControl />
      <RegImportReadValidations />
      <RegImportConnectValidations />
      <RegImportAction />
    </div>
  )
}
